import { useState, useEffect } from 'react'
import { getOrganizationProfile } from 'src/common/api/organizations'
import { useAuth } from 'src/common/context'
import { BlockchainDetailsModel } from 'src/common/api/organizations/models'
import { WalletModel } from 'src/common/api/wallets/models'
import { alertNotification } from 'src/ui'

const useProfile = () => {
  const { user } = useAuth()
  const [orgBlockchainDetails, setOrgBlockchainDetails] = useState<BlockchainDetailsModel[]>([])
  const [displayWallets, setDisplayWallets] = useState<WalletModel[]>([])
  const [organization, setOrganization] = useState<{ orgName: string; email: string } | null>(null)
  const [blockchainIdx, setBlockchainIdx] = useState(0)
  const [showQR, setShowQR] = useState(false)

  const fetchOrganizationBlockchainDetails = async () => {
    try {
      const response = await getOrganizationProfile()
      const orgDetails = response.data.organizationDetails
      const blockchainDetails = response.data.blockchainDetails || []

      setOrganization({
        orgName: orgDetails.orgName,
        email: orgDetails.email
      })

      setOrgBlockchainDetails(blockchainDetails)

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const transformedWallets: WalletModel[] = blockchainDetails.map((detail: any) => ({
        id: detail.id,
        address: detail.address,
        name: detail.name,
        chain: detail.chain
      }))
      setDisplayWallets(transformedWallets)
    } catch (err) {
      console.error('Failed to fetch organization blockchain details:', err)
    }
  }

  const getDetails = async () => {
    try {
      await fetchOrganizationBlockchainDetails()
    } catch (err) {
      alertNotification('Fetching organization details failed. Please contact support.', 'error')
    }
  }

  const copyToClipboard = (value: string) => {
    navigator.clipboard.writeText(value)
    alertNotification('Successfully copied to clipboard!', 'success')
  }

  const openQR = (idx: number) => {
    setBlockchainIdx(idx)
    setShowQR(true)
  }

  const closeQR = () => {
    setShowQR(false)
  }

  useEffect(() => {
    getDetails()
  }, [])

  useEffect(() => {
    fetchOrganizationBlockchainDetails()
  }, [user?.organization_id])

  return {
    user,
    organization,
    wallets: displayWallets,
    blockchainIdx,
    showQR,
    orgBlockchainDetails,
    copyToClipboard,
    openQR,
    closeQR
  }
}

export default useProfile
